(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var bodyBackgroundColor = '#293440';
var bodyTextColor = '#f6f6f6';
var primaryFaded = '#23525c';
var primaryColor = '#0ff';
var palette = {
  background: '#293440',
  text: '#fff',
  anonymous: '#23525c',
  anonymousText: '#0ff',
  headings: '#fefefe',
  divider: '#23525c',
  backgroundAlternate: '#23525c',
  danger: '#ff004d',
  error: '#ff004d',
  warning: '#f2994a'
};
var _default = {
  id: 'designi-contrast-theme',
  name: 'Designi Contrast Theme',
  "default": true,
  mode: 'Dark',
  logos: {},
  styles: {
    fonts: {
      primary: 'Mabry Pro',
      secondary: 'Lato, sans-serif'
    },
    colors: _objectSpread({
      bodyBackgroundColor: '#293440',
      bodyTextColor: '#fff',
      bodySecondaryTextColor: '#f6f6f6',
      primaryFadedColor: '#23525c',
      primaryColor: '#0ff',
      primaryText: '#293440',
      secondaryColor: '#f6f6f6',
      errorColor: '#ff004d',
      primary: '#0ff',
      secondary: '#f6f6f6',
      tertiary: '#f6f6f6',
      success: '#2db47d',
      positive: '#2db47d',
      negative: '#2db47d'
    }, palette),
    Button: {},
    '[variant="default"]': {},
    Input: {
      border: "2px solid ".concat(primaryFaded)
    },
    'Input:active': {
      border: "2px solid ".concat(primaryColor)
    },
    primary: {
      color: '#0075ff',
      background: '#293440',
      'border-color': '#eee'
    },
    secondary: {
      color: '#293440',
      background: '#f6f6f6'
    },
    'secondary Button.primary': {
      color: '#293440',
      background: '#0ff'
    },
    'Button.primary': {
      color: '#fff',
      background: '#0075ff'
    },
    inverted: {
      color: '#fff',
      background: '#293440'
    },
    'inverted primary': {
      color: '#0ff',
      background: '#293440'
    },
    tertiary: {
      base: {
        color: '#0ff',
        background: '#293440'
      },
      'Button.primary': {
        color: '#0ff',
        background: '#293440'
      }
    },
    'secondary primary': {
      color: '#0ff',
      background: '#293440'
    },
    'secondary secondary': {
      color: '#fff',
      background: '#293440'
    }
  }
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(bodyBackgroundColor, "bodyBackgroundColor", "/home/vsts/work/1/s/src/themes/contrast.js");
  reactHotLoader.register(bodyTextColor, "bodyTextColor", "/home/vsts/work/1/s/src/themes/contrast.js");
  reactHotLoader.register(primaryFaded, "primaryFaded", "/home/vsts/work/1/s/src/themes/contrast.js");
  reactHotLoader.register(primaryColor, "primaryColor", "/home/vsts/work/1/s/src/themes/contrast.js");
  reactHotLoader.register(palette, "palette", "/home/vsts/work/1/s/src/themes/contrast.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/themes/contrast.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();